import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex flex-col items-center justify-center h-full bg-gray-900 text-red-400 p-8">
                    <h1 className="text-2xl font-bold mb-4">Something went wrong</h1>
                    <div className="bg-gray-800 p-4 rounded border border-red-900/50 max-w-2xl overflow-auto">
                        <pre className="text-sm font-mono whitespace-pre-wrap">
                            {this.state.error && this.state.error.toString()}
                        </pre>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
